import CustomTable from "../CustomTable";
import routes from "../../../engine/routes";
import React from "react";
import { t } from "i18next";
import {
  formatCurrency,
  languagesList,
  renderStatusPrestation,
  renderTypePrestation,
  renderUserName,
} from "../../../utils/constants";
import { Button, Space } from "antd";
import _ from "lodash";
import { BillsExportsExcel } from "../../../pages/Billing/BillingList/BillsExportsExcel";
import { IoIosArrowDropright, IoMdDownload } from "react-icons/io";
import { CiSquareMore } from "react-icons/ci";

export const RenderCostsTable = ({ cost }) => {
  const [showDetails, setShowDetails] = React.useState(false);
  const uniqueInterprete = new Set();

  let newArrCosts = cost.costsMultiple.map(obj => {
    let pres = cost.prestations.find(e => e._id === obj?.prestationId);

    if (pres === undefined) {
    } else {
      uniqueInterprete.add(pres.interprete._id);
    }

    return {
      ...obj,
      prestation: pres,
    };
  });

  let arrayInterprete = [...uniqueInterprete];

  const columns = multiple => {
    return [
      {
        title: t("renderCostsTable.reference"),
        dataIndex: "reference",
        key: "reference",
        render: (r, i) => i?.prestation?.reference,
        sorter: (a, b) => {
          return a?.prestation.reference - b?.prestation.reference;
        },
      },
      {
        title: t("renderCostsTable.interprete"),
        dataIndex: "prestation",
        key: "prestation",
        sorter: (a, b) => {
          const nameA = renderUserName(a.prestation.interprete);
          const nameB = renderUserName(b.prestation.interprete);

          return nameA.localeCompare(nameB);
        },
        render: (prestation, record) => {
          return <b>{renderUserName(prestation?.interprete)}</b>;
        },
        filters: arrayInterprete
          .filter(e => e !== "" && e !== null)
          .map(o => {
            let name = cost.prestations.find(e => e.interprete._id === o);

            return { text: renderUserName(name.interprete), value: o };
          }),
        onFilter: (value, record) => {
          return record.prestation.interprete._id === value;
        },
      },
      {
        title: t("renderCostsTable.prestationType"),
        dataIndex: "type_pres",
        key: "type_pres",
        render: (r, i) =>
          renderTypePrestation(i?.prestation?.intervention?.type),
        sorter: (a, b) => {
          return a.prestation.intervention.type.localeCompare(
            b.prestation.intervention.type,
          );
        },
      },
      {
        title: t("renderCostsTable.language"),
        dataIndex: "lang",
        key: "lang",
        render: (r, i) =>
          i?.prestation?.languages.map(
            p => languagesList().find(e => e?.value === p)?.label,
          ),
        sorter: (a, b) => {
          let stringA = a.prestation.languages.map(e => e).join(" ");
          let stringB = b.prestation.languages.map(e => e).join(" ");

          return stringA.localeCompare(stringB);
        },
      },
      {
        title: t("renderCostsTable.amount"),
        dataIndex: "amount",
        key: "amount",
        render: (r, i) => formatCurrency(i.costParams.total),
        sorter: (a, b) => {
          return a.costParams.total - b.costParams.total;
        },
      },
      showDetails
        ? {
            title: t("renderCostsTable.prestation"),
            dataIndex: "prestation",
            key: "prestation",
            render: (r, i) =>
              formatCurrency(
                i.cost.find(e => e.type === "prestation")?.amount || 0,
              ),
            sorter: (a, b) => {
              const amountA =
                a.cost.find(e => e.type === "prestation")?.amount || 0;
              const amountB =
                b.cost.find(e => e.type === "prestation")?.amount || 0;
              return amountA - amountB;
            },
          }
        : null,

      showDetails
        ? {
            title: t("renderCostsTable.night"),
            dataIndex: "night",
            key: "night",
            render: (r, i) =>
              formatCurrency(i.cost.find(e => e.type === "night")?.amount || 0),
            sorter: (a, b) => {
              const amountA = a.cost.find(e => e.type === "night")?.amount || 0;
              const amountB = b.cost.find(e => e.type === "night")?.amount || 0;
              return amountA - amountB;
            },
          }
        : null,
      showDetails
        ? {
            title: t("renderCostsTable.holiday"),
            dataIndex: "holiday",
            key: "holiday",
            render: (r, i) =>
              formatCurrency(
                i.cost.find(e => e.type === "holiday")?.amount || 0,
              ),
            sorter: (a, b) => {
              const amountA =
                a.cost.find(e => e.type === "holiday")?.amount || 0;
              const amountB =
                b.cost.find(e => e.type === "holiday")?.amount || 0;
              return amountA - amountB;
            },
          }
        : null,
      showDetails
        ? {
            title: t("renderCostsTable.travelFees"),
            dataIndex: "amount",
            key: "amount",
            render: (r, i) =>
              formatCurrency(
                i.cost.find(e => e.type === "travel-public")?.amount || 0,
              ),
            sorter: (a, b) => {
              const amountA =
                a.cost.find(e => e.type === "travel-public")?.amount || 0;
              const amountB =
                b.cost.find(e => e.type === "travel-public")?.amount || 0;
              return amountA - amountB;
            },
          }
        : null,
      showDetails
        ? {
            title: t("renderCostsTable.meals"),
            dataIndex: "meals",
            key: "meals",
            render: (r, i) =>
              formatCurrency(i.cost.find(e => e.type === "meal")?.amount || 0),
            sorter: (a, b) => {
              const amountA = a.cost.find(e => e.type === "meal")?.amount || 0;
              const amountB = b.cost.find(e => e.type === "meal")?.amount || 0;
              return amountA - amountB;
            },
          }
        : null,
      {
        title: t("renderCostsTable.status"),
        dataIndex: "status",
        key: "status",
        render: (r, i) => {
          return renderStatusPrestation(i.prestation, { showControls: false });
        },
      },
    ];
  };

  return (
    <>
      <CustomTable
        scroll={{ y: 1000, x: showDetails === true ? 1800 : 800 }}
        hasPagination={false}
        key={Math.random()}
        onRowLink={record => {
          return routes.prestations(record.prestation._id).detail.path;
        }}
        dataSource={newArrCosts.sort((a, b) => a.reference - b.reference)}
        columns={columns().filter(e => e !== null)}
        rowKey={record => record?.prestationId}
        pagination={{
          hideOnSinglePage: false,
          position: ["topRight"],
          // defaultPageSize: pagination.pageSize,
          // pageSizeOptions: [
          //   ...[10, 20, 50, 100, 250],
          //   ...(advancedSearch && searchState?.advancedCols ? [500, 1000] : []),
          // ],
          showSizeChanger: true,
          // current: pagination.currentPage,
          // total: totals[key],
          showTotal: (total, range) => (
            <span>
              <Button
                size={"small"}
                type={"primary"}
                style={{ marginRight: 10 }}
                onClick={async () => {
                  setShowDetails(!showDetails);
                }}
              >
                <Space>
                  <IoIosArrowDropright size={20} />
                  {t("showDetails")}
                </Space>
              </Button>
            </span>
          ),
        }}
      />
    </>
  );
};
